import useAuth from './useAuth';

const useUserRole = () => {
  const auth = useAuth();
  return auth?.user?.role;
};

export default useUserRole;
